
import { Checkbox, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { styled } from '@mui/material/styles';

const TinySelect = styled(Select)(({ theme }) => ({
  minHeight: 25,
  height: 25,
  fontSize: '0.85rem',
  '& .MuiSelect-select': {
    minHeight: 25,
    height: 25,
    paddingTop: 4,
    paddingBottom: 4,
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiFilledInput-root': {
    minHeight: 25,
    height: 25,
    paddingTop: 0,
    paddingBottom: 0,
  },
}));


export const TopBar = ({
    interval = 'D',
    darkMode = true,
    indexList,
    selectList,
    handleIntervalChange,
    handleWatchlist,
    handleThemeChange,
}) => {

    const intervalList = ['D', 'W', 'M']

    return (
        <div>
            <Grid container columnSpacing={1} sx={{ marginTop: '1px' }}>
            {/* <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center' }}>
                <FormControl variant="filled" size="small" fullWidth>
                <TinySelect
                    value={interval}
                    onChange={handleIntervalChange}
                    MenuProps={{ PaperProps: { sx: { '& .MuiMenuItem-root': { py: 0.5 } } } }}
                >
                    { intervalList.map ( (item, idx) => {
                        return <MenuItem value={item} key={idx}>{ item }</MenuItem>
                    })}
                </TinySelect>
                </FormControl>
            </Grid>
 */}
            {/* <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center' }}>
                <FormControlLabel
                control={
                    <Checkbox
                    size="small"
                    icon={<RadioButtonUncheckedIcon fontSize="small" />}
                    checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
                    checked={darkMode}
                    onChange={handleThemeChange}
                    sx={{ p: 0 }}
                    />
                }
                label="Dark"
                labelPlacement="start"
                />
            </Grid> */}

            {/* <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center' }}></Grid> */}
            <Grid item xs={10} sx={{ display: 'flex', alignItems: 'center' }}></Grid>

            <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center' }}>
                <FormControl variant="filled" size="small" fullWidth>
                {/* <InputLabel id="Market">Market</InputLabel> */}
                <TinySelect
                    value={selectList}
                    onChange={handleWatchlist}
                    MenuProps={{ PaperProps: { sx: { '& .MuiMenuItem-root': { py: 0.5 } } } }}
                >
                    { indexList.map ( (item, idx) => {
                        return <MenuItem value={item} key={idx}>{ item }</MenuItem>
                    })}
                </TinySelect>
                </FormControl>
            </Grid>
            </Grid>
        </div>
    )
}



export const ChartConfig = ({
    interval = 'D',
    darkMode = true,
    handleIntervalChange,
    handleThemeChange,
}) => {

    const intervalList = ['D', 'W', 'M']

    return (
            <Grid container sx={{ backgroundColor: 'darkgrey' }}>
            <Grid item xs={2}></Grid>
            <Grid item xs={5} sx={{ display: 'flex', alignItems: 'left'}}>
                <FormControl variant="filled" size="small" fullWidth>
                <InputLabel id="interval">Interval</InputLabel>
                <Select
                    value={interval}
                    onChange={handleIntervalChange}
                    MenuProps={{ PaperProps: { sx: { '& .MuiMenuItem-root': { py: 0.5 } } } }}
                >
                    { intervalList.map ( (item, idx) => {
                        return <MenuItem value={item} key={idx}>{ item }</MenuItem>
                    })}
                </Select>
                </FormControl>
            </Grid>

            <Grid item xs={5} sx={{ display: 'flex', justifyContent: 'left' }}>
                <FormControlLabel
                control={
                    <Checkbox
                    size="small"
                    icon={<RadioButtonUncheckedIcon fontSize="small" />}
                    checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
                    checked={darkMode}
                    onChange={handleThemeChange}
                    />
                }
                label="Dark"
                labelPlacement="start"
                />
            </Grid>
            </Grid>
    )
}